import React from 'react';
import { ConfigProvider } from 'antd';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import themes from './config/theme/theme.config';
import AppLocale from './config/translation';
import ptBR from "antd/lib/locale/pt_BR";

export default function AppProvider({ children }) {
  const { locale } = useSelector(state => state.LanguageSwitcher.language);
  const themeName = 'defaultTheme';
  const currentAppLocale = AppLocale[locale];
  return (
    <ConfigProvider locale={ptBR}>
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <ThemeProvider theme={themes[themeName]}>{children}</ThemeProvider>
      </IntlProvider>
    </ConfigProvider>
  );
}
